import { useRef } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100%",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
    "pointer-events": props => (props.show ? "auto" : "none"),
    "z-index": 12,
    "background-color": "rgba(0, 0, 0, 0.5)",
    opacity: props => (props.show ? 1 : 0),
    transition: "opacity 0.2s ease",
  },
  lightbox: {
    display: "flex",
    "flex-direction": "row",
    overflow: "hidden",
    "border-radius": 8,
    "max-height": "85%",
    width: 1100,
    "min-height": 750,
    "max-width": "95%",
    "overflow-x": "auto",
  },
  sidebar: {
    width: 300,
    "flex-shrink": 0,
    display: "flex",
    "flex-direction": "column",
    "align-items": "center",
    background: "#252525",
    color: "white",
    "& hr": {
      width: "80%",
    },
  },
  content: {
    background: "#313131",
    padding: 15,
    "flex-grow": 1,
    color: "white",
    "min-width": 300,
    "overflow-y": "auto",
    position: "relative",
  },
});

const SidebarLightbox = ({ show, sidebar, children, onClose }) => {
  const classes = useStyles({ show });
  const ref = useRef();

  return (
    <div
      ref={ref}
      className={classes.background}
      onClick={e => {
        if (e.target === ref.current) {
          onClose(e);
        }
      }}
    >
      <div className={classes.lightbox}>
        <div className={classes.sidebar}>{sidebar}</div>
        <div className={classes.content}>{children}</div>
      </div>
    </div>
  );
};

export default SidebarLightbox;
